export default {
  array_get(i, k, d) {
    if (typeof d === 'undefined') {
      d = null
    }
    if (!k) return i

    let s = k.split('.')

    let o = i

    for (let x = 0; x < s.length; x++) {
      if (null !== o && o.hasOwnProperty(s[x])) {
        o = o[s[x]]
      } else {
        return d
      }
    }

    return o
  },
  array_set(i, k, v) {
    let x
    if (!k) return
    const s = k.split('.')
    let h = i
    for (x = 0; x < s.length - 1; x++) {
      if (h.hasOwnProperty(s[x])) {
        h = h[s[x]]
      } else {
        for (let y = s.length - 1; x <= y; y--) {
          const w = v
          v = {}
          v[s[y]] = w
        }
        h[s[x]] = v[s[x]]
        return
      }
    }
    h[s[x]] = v
  },
  array_dot(i, p) {
    const o = {}
    p = p || ''

    if (p) {
      p = `${p}.`
    }

    let x
    if (typeof i == 'object') {
      for (const k in i) {
        if (i.hasOwnProperty(k)) {
          if (typeof i[k] == 'object') {
            x = this.array_dot(i[k], k)
            for (const l in x) {
              o[p + l] = x[l]
            }
          } else {
            o[p + k] = i[k]
          }
        }
      }
    }
    return o
  },
  array_flatten(i) {
    i = Object(i)
    let o = []

    for (let k in i) {
      if (i.hasOwnProperty(k)) {
        if (typeof i[k] == 'object') {
          o = o.concat(array_flatten(i[k]))
        } else {
          o.push(i[k])
        }
      }
    }
    return o
  },
  array_first(a, f, d) {
    if (!f && a.length) {
      return a[0]
    }
    for (let x = 0; x < a.length; x++) {
      if (f(a[x])) return a[x]
    }
    return d
  },
  array_except(a, ks) {
    /**
     *  does not account for array_dot sub-keys
     */
    let b = jQuery.extend(true, {}, a)
    ks.forEach(function (k) {
      delete b[k]
    })
    return b
  },
  array_only(a, ks) {
    /**
     *  does not account for array_dot sub-keys
     */
    let b = jQuery.extend(true, {}, a)

    for (let k in a) {
      if (ks.indexOf(k) === -1) delete b[k]
    }

    return b
  },
  array_fetch(arr, key) {
    let r = []
    for (let k in arr) {
      if (arr.hasOwnProperty(k)) {
        if (array_has(arr[k], key)) {
          r.push(array_get(arr[k], key))
        }
      }
    }
    return r
  },
  array_has(arr, key) {
    return array_get(arr, key, false) !== false && array_get(arr, key, true) !== true
  },
}
